module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pshou10-c29d86d58063207803a1ac6fcc84274c.jpg";